export interface HttpResponse<T> {
  data?: T;
}

export interface HttpLoginResponse {
  accessToken: string;
  code: string;
}
